module.exports = __webpack_public_path__ + "static/media/icon_status_stay.b54315cb.svg";